<template>
  <div class="fnb-checkout-wrapper">
    <b-modal
      hide-footer
      title="Add Customer Details"
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="fnb-customer-details"
      id="fnb-customer-details"
    >
      <div class="col-12 h-100">
        <div class="pos-mobile-number">
          <div>
            <div class="row">
              <div class="col-12 mb-4">
                <div class="country-code">
                  <div class="d-flex align-items-center">
                    <!-- <b-dropdown :text="SelectedCountryCode">
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler(countrycode)"
                      >{{ countrycode.country_mob_code }}</b-dropdown-item>
                    </b-dropdown>-->
                    <b-dropdown
                      :text="getCustMobCode ? getCustMobCode : 'Code'"
                      variant="dropdown-curve"
                      class="w-50 text-center mr-3"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler(countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <input
                      type="number"
                      :disabled="isEdit"
                      v-model="input_number"
                      placeholder="Mobile Number"
                      class="mobile-number"
                      v-on:keydown="
                        e => {
                          if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                            e.preventDefault();
                          }
                        }
                      "
                    />
                    <span
                      @click="onEditPhoneNumber()"
                      class="edit-pen ml-2"
                    ></span>
                  </div>
                </div>
              </div>
              <!-- <div> -->
              <form class="row">
                <!--class="col-12 mb-4"-->
                <div v-if="isSearch" class="col-12">
                  <input
                    type="email"
                    v-model="email_address"
                    name="Email Address"
                    placeholder="Email Address"
                    v-validate="'required|email'"
                    id="custEmailAdd"
                    @focus="onClickInputHandler('showEmailKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('Email Address')">{{
                      errors.first("Email Address")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custEmailAdd'"
                    :onClickFun="
                      () => {
                        Object.keys(keyboardsVisible).map(x => {
                          if (x == 'showEmailKeyboard') {
                            keyboardsVisible[x] = !keyboardsVisible[x];
                          } else {
                            keyboardsVisible[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'custEmailAdd'"
                    :showOrHide="keyboardsVisible.showEmailKeyboard"
                    :initialValue="email_address"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="
                      () => {
                        keyboardsVisible.showEmailKeyboard = false;
                      }
                    "
                    @changeKeyboardInput="email_address = $event"
                    @onClickClose="
                      () => {
                        keyboardsVisible.showEmailKeyboard = false;
                      }
                    "
                  />
                </div>
                <!--class="col-6 mb-4"-->
                <div v-if="isSearch" class="col-6">
                  <input
                    type="text"
                    name="First Name"
                    v-model="first_name"
                    placeholder="First Name"
                    v-validate="'required'"
                    id="custfirstname"
                    @focus="onClickInputHandler('showFirstNameKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('First Name')">{{
                      errors.first("First Name")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custfirstname'"
                    :onClickFun="
                      () => {
                        Object.keys(keyboardsVisible).map(x => {
                          if (x == 'showFirstNameKeyboard') {
                            keyboardsVisible[x] = !keyboardsVisible[x];
                          } else {
                            keyboardsVisible[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'custfirstname'"
                    :showOrHide="keyboardsVisible.showFirstNameKeyboard"
                    :initialValue="first_name"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="
                      () => {
                        keyboardsVisible.showFirstNameKeyboard = false;
                      }
                    "
                    @changeKeyboardInput="first_name = $event"
                    @onClickClose="
                      () => {
                        keyboardsVisible.showFirstNameKeyboard = false;
                      }
                    "
                  />
                </div>
                <!--class="col-6 mb-4"-->
                <div v-if="isSearch" class="col-6">
                  <input
                    type="text"
                    name="Last Name"
                    v-validate="'required'"
                    v-model="last_name"
                    placeholder="Last name"
                    id="custlastname"
                    @focus="onClickInputHandler('showLastNameKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('Last Name')">{{
                      errors.first("Last Name")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custlastname'"
                    :onClickFun="
                      () => {
                        Object.keys(keyboardsVisible).map(x => {
                          if (x == 'showLastNameKeyboard') {
                            keyboardsVisible[x] = !keyboardsVisible[x];
                          } else {
                            keyboardsVisible[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'custlastname'"
                    :showOrHide="keyboardsVisible.showLastNameKeyboard"
                    :initialValue="last_name"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="
                      () => {
                        keyboardsVisible.showLastNameKeyboard = false;
                      }
                    "
                    @changeKeyboardInput="last_name = $event"
                    @onClickClose="
                      () => {
                        keyboardsVisible.showLastNameKeyboard = false;
                      }
                    "
                  />
                </div>

                <div v-if="isSearch" class="col-12">
                  <div class="d-flex pb-2">
                    <b-form-checkbox
                      class="j-checkbox"
                      v-model="is_loyality_subscribe"
                      unchecked-value="N"
                      value="Y"
                    ></b-form-checkbox>
                    <span>{{ $t("subscribeloyality") }}</span>
                  </div>
                </div>
              </form>
              <!-- </div> -->

              <div class="col-11 mx-auto">
                <div class="row">
                  <!-- <div class="col-4 mb-2" v-for="(loop , mobile) in 12" :key="mobile">
                  <button>{{mobile}}</button>-->

                  <div
                    class="col-4 mb-2"
                    v-for="(value, index) in phone_value"
                    :key="index"
                  >
                    <button
                      v-if="index == phone_value.length - 1"
                      v-on:click="onSliceNUmber()"
                      class="number"
                    >
                      {{ value.name }}
                    </button>
                    <button
                      v-else-if="value.name != ''"
                      v-on:click="onClicknumber(index)"
                      class="number"
                    >
                      {{ value.name }}
                    </button>
                    <button
                      v-else
                      @click.prevent.stop="clearInput"
                      class="number"
                    >
                      C
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mx-auto">
          <div class>
            <button
              @click="$bvModal.hide('fnb-customer-details')"
              class="btn-outline-blue-lg bg-transparent text-dark mr-1"
            >
              Cancel
            </button>
            <button
              v-on:click="onClickDelete()"
              class="btn-outline-blue-lg bg-transparent text-dark mr-1"
            >
              Clear
            </button>
            <button
              v-if="!isSearch"
              v-on:click="onSearch()"
              class="btn-blue-lg bg-blue text-white"
            >
              Search
            </button>
            <button
              v-else-if="isOldCustomer"
              v-on:click="onUpdateCustomerDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Update
            </button>
            <button
              v-else
              v-on:click="onSaveDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- loyaltyMoadal -->

    <div class="row h-100">
      <div class="col-lg-5 col-xl-3 pr-0">
        <button
          v-for="(singlePaymentMode, singlePaymentIndex) in paymentModesFiltered"
          :key="singlePaymentIndex"
          class="btn-paymentType"
            :class="[
              { 'active ': selectedPaymentMode.pm_id == singlePaymentMode.pm_id || (singlePaymentMode.pm_id == 'GiftCard' && giftCardPmIds.includes(String(selectedPaymentMode.pm_id))) },
              { ' pm_disbaled ': machineDisplay.processing }
            ]"
          v-on:click="onSelectPaymentType(singlePaymentMode)"
          :disabled="
            (singlePaymentMode.pm_id == 9
              ? checkCredit(singlePaymentMode)
              : machineDisplay.processing ? machineDisplay.processing : false)
          "
          :style="
            singlePaymentMode.pm_id == 9
              ? checkCredit(singlePaymentMode)
                ? 'background: #aba6a6;'
                : ''
              : ''
          "
        >
          {{ singlePaymentMode.pm_payment_mode }}
        </button>
      </div>
      <div class="col-lg-7 col-xl-9">
        <div
          class="cash-payment-container"
          :class="
            selectedPaymentMode.pm_id == 1 ? 'border-top-left-radius-0' : ''
          "
          v-if="selectedPaymentMode.pm_id == 1"
        >
          <PosGlobalCalculator
            v-if="!isBoxofficeflag"
            :resetAmount="onResetFnBCashAmout"
            :cashdata="Cashdata"
            :onAddMoreCash="addCashHandler"
            :inputvalue="cashInputValue"
            :inputChange="cashInputChange"
            :changeAmount="
              ChangeAmount >=
              FnBItemsTotalPrice +
                ticketValue +
                selectedAddonsTotalPrice +
                customizationTotalPrice
                ? ChangeAmount -
                  FnBItemsTotalPrice -
                  ticketValue -
                  selectedAddonsTotalPrice -
                  customizationTotalPrice
                : 0
            "
            class="mx-auto"
          />
          <!-- OLD - :changeAmount="ChangeAmount > FnBItemsTotalPrice + ticketValue + selectedAddonsTotalPrice ? ChangeAmount - FnBItemsTotalPrice - ticketValue - selectedAddonsTotalPrice : 0" -->

          <!-- {{isBoxofficeflag}} -->
          <PosGlobalCalculator
            v-if="isBoxofficeflag"
            :resetAmount="onResetFnBCashAmout"
            :cashdata="Cashdata"
            :onAddMoreCash="addCashHandler"
            :inputvalue="cashInputValue"
            :inputChange="cashInputChange"
            :changeAmount="
              ChangeAmount >=
              FnBItemsTotalPrice +
                ticketValue +
                selectedAddonsTotalPrice +
                customizationTotalPrice
                ? ChangeAmount -
                  FnBItemsTotalPrice -
                  ticketValue -
                  selectedAddonsTotalPrice -
                  customizationTotalPrice
                : 0
            "
            class="mx-auto"
          />
          <div
            class="mx-auto text-center"
            v-if="isBoxofficeflag && totalSeats.length > 0 && false"
          >
            <button class="btn-blue-lg px-4 w-50" @click="onClickPayBox()">
              {{ $t("print") }} {{ $t("of") }}
              {{ currFormat(toPay) }}
              {{ currencyCode }}
            </button>
          </div>
          <div class="mx-auto text-center" v-else-if="false">
            <button 
            class="btn-blue-lg px-4 w-50" 
            :class="[
                    disableCheckoutBtn
                      ? 'disabled'
                      : ''
                  ]" 
                  v-bind:style="{
                    'pointer-events':
                      disableCheckoutBtn
                        ? 'none'
                        : 'all'
                  }" @click="onClickFnbPay()">
              {{ $t("print") }} {{ $t("of") }}
              {{ currFormat(toPay) }}
              {{ currencyCode }}
            </button>
          </div>

          <div
            class="mx-auto text-center"
            v-if="
              getOffersCollection.filter(x => checkOfferTypeCount(x)) &&
                getOffersCollection.filter(x => checkOfferTypeCount(x)).length >
                  0
            "
          >
            <div
              v-if="checkOpenOfferModal()"
              class="fs-16 text-primary font-weight-bold"
              @click="showNewOffersPopup()"
            >
              ({{
                getOffersCollection.filter(x => checkOfferTypeCount(x)).length
              }})&nbsp; Offer(s) Available
            </div>
          </div>
        </div>
        <!-- OLD :changeAmount="ChangeAmount > FnBItemsTotalPrice + ticketValue + selectedAddonsTotalPrice ? ChangeAmount - FnBItemsTotalPrice - ticketValue - selectedAddonsTotalPrice : 0" -->
        <!-- cash card flow in progress -->
        <div
          class="card-payment-contianer"
          v-if="
            selectedPaymentMode.pm_id == 12 || selectedPaymentMode.pm_id == 13
          "
        >
          <section class="row">
            <div class="col-12 mb-5">
              <div class="row pos_booking_input_material">
                <div class="col-6 input-material">
                  <input
                    placeholder="Voucher Code"
                    type="text"
                    v-model="VoucherCodeDeounce"
                    @input="onInputVoucherCode($event)"
                    name="VoucherCodeDeounce"
                    id="VoucherCodeDeounce"
                    class="form-control is_active"
                    @click="onClickInputHandler('showVoucherCodeKeyboard')"
                  />
                  <label class="">{{ $t("VoucherCodeDeounce") }}</label>
                  <VkeyboardFloat
                    :ID="'VoucherCodeDeounce'"
                    :onClickFun="
                      () => {
                        Object.keys(keyboardsVisible).map(x => {
                          if (x == 'showVoucherCodeKeyboard') {
                            keyboardsVisible[x] = !keyboardsVisible[x];
                          } else {
                            keyboardsVisible[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'VoucherCodeDeounce'"
                    :showOrHide="keyboardsVisible.showVoucherCodeKeyboard"
                    :initialValue="VoucherCodeDeounce"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="onInputVoucherCode"
                    @changeKeyboardInput="VoucherCodeDeounce = $event"
                    @onClickClose="
                      () => {
                        keyboardsVisible.showVoucherCodeKeyboard = false;
                      }
                    "
                  />
                </div>

                <div class="col-6 input-material">
                  <input
                    placeholder="Comment"
                    type="text"
                    :value="getTransactionComment"
                    @input="onInputComment($event)"
                    name="voucherComment"
                    id="voucherComment"
                    class="form-control is_active"
                    @click="onClickInputHandler('showCommentKeyboard')"
                  />
                  <label class="">{{ "Enter Comment" }}</label>
                  <VkeyboardFloat
                    :ID="'voucherComment'"
                    :onClickFun="
                      () => {
                        Object.keys(keyboardsVisible).map(x => {
                          if (x == 'showCommentKeyboard') {
                            keyboardsVisible[x] = !keyboardsVisible[x];
                          } else {
                            keyboardsVisible[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'voucherComment'"
                    :showOrHide="keyboardsVisible.showCommentKeyboard"
                    :initialValue="getTransactionComment"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="
                      () => {
                        keyboardsVisible.showCommentKeyboard = false;
                      }
                    "
                    @changeKeyboardInput="
                      onInputComment({
                        target: {
                          value: $event
                        }
                      })
                    "
                    @onClickClose="
                      () => {
                        keyboardsVisible.showCommentKeyboard = false;
                      }
                    "
                  />
                </div>
              </div>
            </div>
            <article class="col-md-12 col-lg-12 col-xl-8">
              <section class="row voucher_btn_row">
                <article
                  class="col-6"
                  v-for="(OffersVoucherItem,
                  OffersVoucherIndex) in getOffersVoucherCollection"
                  :key="OffersVoucherIndex"
                  v-if="
                    OffersVoucherItem.is_open_voucher == 'Y' &&
                      OffersVoucherItem.is_complemetory_ticket == 'N'
                  "
                >
                  <div
                    class="voucher_btn"
                    @click="onApplyVoucherBox(OffersVoucherItem)"
                    :class="
                      offerApplied
                        ? offerApplied.voucher_code ==
                          OffersVoucherItem.voucher_code
                          ? 'active'
                          : (getTicketTypePrice(OffersVoucherItem) &&
                              OffersVoucherItem.tt_id) ||
                            !OffersVoucherItem.tt_id
                          ? ''
                          : 'inactive'
                        : (getTicketTypePrice(OffersVoucherItem) &&
                            OffersVoucherItem.tt_id) ||
                          !OffersVoucherItem.tt_id
                        ? ''
                        : 'inactive'
                    "
                  >
                    <div class="voucher_btn__name">
                      <p>
                        {{ OffersVoucherItem.voucher_title }}
                      </p>
                    </div>
                    <div class="voucher_btn__details">
                      <!-- <p class="voucher_btn__screen">Saal 2</p> -->
                      <div
                        class="voucher_btn__time"
                        v-if="getTicketTypePrice(OffersVoucherItem)"
                      >
                        <p>
                          {{ getTicketTypePrice(OffersVoucherItem) }}
                          {{ currencyData.curr_code }}
                        </p>
                      </div>
                      <div
                        class="voucher_btn__screen"
                        v-if="
                          !(
                            (getTicketTypePrice(OffersVoucherItem) &&
                              OffersVoucherItem.tt_id) ||
                            !OffersVoucherItem.tt_id
                          )
                        "
                      >
                        <p>({{ $t("voucher_not_available") }})</p>
                      </div>
                    </div>
                  </div>
                </article>
                <article class="col-12">
                  <section class="row">
                    <article class="col-6">
                      <div class="voucher_btn" v-b-modal.pos-applicable-offers>
                        <div class="voucher_btn__name">
                          <p>View Offers</p>
                        </div>
                        <!-- <div class="voucher_btn__details"> -->
                        <!-- <div class="voucher_btn__screen">
                            <p>
                              Saal 2
                            </p>
                          </div>
                          <div class="voucher_btn__time">
                            <p>
                              18:00
                            </p>
                            </div> -->
                        <!-- </div> -->
                      </div>
                    </article>
                  </section>
                </article>
              </section>
            </article>
          </section>
          <section class="row"></section>
          <!-- IN PROGRESS -->
        </div>

        <div
          class="card-payment-contianer"
          v-if="selectedPaymentMode.pm_id == 9"
        >
          <section class="row">
            <div class="col-12 mb-5">
              <div class="row pos_booking_input_material">
                <div class="col-6 input-material">
                  <input
                    placeholder="Invoice No."
                    type="text"
                    v-model="invoiceNumberComputed"
                    @input="onInputInvoiceNumber($event)"
                    name="invoiceNumber"
                    id="invoiceNumber"
                    class="form-control is_active"
                    ref="invoiceNumber"
                    @click="onClickInputHandler('showInvoiceNumberKeyboard')"
                  />
                  <label class="">{{ "Invoice Number" }}</label>
                  <VkeyboardFloat
                    :ID="'invoiceNumber'"
                    :onClickFun="
                      () => {
                        Object.keys(keyboardsVisible).map(x => {
                          if (x == 'showInvoiceNumberKeyboard') {
                            keyboardsVisible[x] = !keyboardsVisible[x];
                          } else {
                            keyboardsVisible[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'invoiceNumber'"
                    :showOrHide="keyboardsVisible.showInvoiceNumberKeyboard"
                    :initialValue="invoiceNumberComputed"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="onInputInvoiceNumber"
                    @changeKeyboardInput="invoiceNumberComputed = $event"
                    @onClickClose="
                      () => {
                        keyboardsVisible.showInvoiceNumberKeyboard = false;
                      }
                    "
                  />
                </div>

                <div class="col-6 input-material">
                  <input
                    placeholder="paymentRemarks"
                    type="text"
                    :value="getPaymentRemark"
                    @input="onInputRemark({ event: $event, type: 1 })"
                    name="paymentRemarks"
                    id="paymentRemarks"
                    class="form-control is_active"
                    @click="onClickInputHandler('showPaymentRemarkKeyboard')"
                  />
                  <label class="">{{ "Enter Comment" }}</label>
                  <VkeyboardFloat
                    :ID="'paymentRemarks'"
                    :onClickFun="
                      () => {
                        Object.keys(keyboardsVisible).map(x => {
                          if (x == 'showPaymentRemarkKeyboard') {
                            keyboardsVisible[x] = !keyboardsVisible[x];
                          } else {
                            keyboardsVisible[x] = false;
                          }
                        });
                      }
                    "
                  />
                  <Vkeyboard
                    :inputName="'paymentRemarks'"
                    :showOrHide="keyboardsVisible.showPaymentRemarkKeyboard"
                    :initialValue="getPaymentRemark"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="
                      () => {
                        keyboardsVisible.showPaymentRemarkKeyboard = false;
                      }
                    "
                    @changeKeyboardInput="
                      onInputRemark({
                        event: {
                          target: {
                            value: $event
                          }
                        },
                        type: 1
                      })
                    "
                    @onClickClose="
                      () => {
                        keyboardsVisible.showPaymentRemarkKeyboard = false;
                      }
                    "
                  />
                </div>

                <div class="col-12">
                  <img
                    src="@/assets/img/icons/unpaid-reservation.svg"
                    height="120"
                    width="245"
                    class="mx-auto d-block mt-5 pl-4"
                  />
                </div>
                <div class="mx-auto text-center col-12">
                  <button class="btn-blue mt-5 px-5" @click="makePayment()">
                    Proceed
                    {{
                      parseFloat(
                        ticketValue +
                          FnBItemsTotalPrice +
                          selectedAddonsTotalPrice +
                          customizationTotalPrice
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    }}&nbsp;{{ getFnBCurrency.curr_code }}
                  </button>
                </div>
              </div>
            </div>
          </section>
          <section class="row"></section>
          <!-- IN PROGRESS -->
        </div>

        <div
          class="card-payment-contianer"
          :class="
            selectedPaymentMode.pm_id == 11 ? 'border-top-left-radius-0' : ''
          "
          v-if="selectedPaymentMode.pm_id == 11"
        >
          <h6 class="mb-3">
            {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
          </h6>
          <h6 class="mb-3">
            {{ $t("mobileno") }} : {{ customer_mobile_number }}
          </h6>
          <h6 class="mb-3">{{ $t("emailaddress") }} : {{ email_address }}</h6>
          <h6 class="mb-3">
            {{ $t("full") }} {{ $t("name") }} : {{ first_name }} {{ last_name }}
          </h6>
          <div class="dropdown-curve-container" v-if="false">
            <label
              :class="
                selectedCashCard && selectedCashCard.cash_card_number.length > 0
                  ? 'shift-up'
                  : ''
              "
              >Select Cash Card</label
            >
            <b-dropdown
              :text="selectedCashCard ? selectedCashCard.cash_card_number : ''"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(card, cardIndex) in cashCards"
                href="#"
                :key="cardIndex"
                name="cashCardDropdown"
                id="cashCardDropdown"
                v-on:click="selectCashCard(card)"
                >{{ card.cash_card_number }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <div class="row mt-3" v-if="selectedCashCard && false">
            <div class="col-6">
              <h6 class>
                Balance :
                {{ parseFloat(selectedCashCard.remaining_balance).toFixed(this.MIN_FRACTION_DIGITS) }}
              </h6>
            </div>
            <div
              v-if="selectedCashCard.remaining_balance && paidflag == false"
              class="col-6"
            >
              <button
                :disabled="disablePayNow"
                @click.prevent.stop="payCashCardFnbBox()"
                class="btn-blue"
              >
                {{ $t("Pay Now") }}
              </button>
            </div>
          </div>
          <CashCardPos SectionType="debit" :onClickAddMoney="onClickAddMoney" />
        </div>
        <div
          class="card-payment-contianer"
          v-if="
            selectedPaymentMode.pm_id == 2 || selectedPaymentMode.pm_id == 3
          "
        >
          <h6 class="mb-3">
            {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
          </h6>
          <form>
            <input
              type="text"
              placeholder="Amount"
              disabled
              :value="
                parseFloat(
                  ticketValue +
                    FnBItemsTotalPrice +
                    selectedAddonsTotalPrice +
                    customizationTotalPrice
                ).toFixed(this.MIN_FRACTION_DIGITS) +
                  ' ' +
                  getFnBCurrency.curr_code
              "
            />
          </form>
          <img
            src="@/assets/img/pos/card-payment.png"
            height="100"
            width="145"
            class="mx-auto d-block mt-5"
          />

          <div
            class="row d-flex justify-content-center mt-1"
            v-if="USE_TIM_INTEGRATION == 'Y'"
          >
            <div class="machine-display">
              <div>
                <b-spinner
                  v-if="machineDisplay.processing"
                  label="Processing..."
                  class="translate-spinner"
                ></b-spinner>
              </div>
              <div v-if="machineDisplay.processing">Processing...</div>
              <div
                v-if="
                  timTimeObj.transactionTimeOut && machineDisplay.processing
                "
              >
                Time Left:&nbsp;<span
                  class="font-weight-bold"
                  style="font-family: monospace;"
                  >{{ timTimeObj.transactionTimeOut }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="row d-flex justify-content-center mt-2"
            v-if="USE_TIM_INTEGRATION == 'Y'"
          >
            <div
              class="btn btn-primary"
              :class="machineDisplay.processing ? 'disCreditPayBtn' : ''"
              :disabled="machineDisplay.processing"
              @click="proceedCreditCard()"
            >
              Proceed
              {{
                parseFloat(
                  ticketValue +
                    FnBItemsTotalPrice +
                    selectedAddonsTotalPrice +
                    customizationTotalPrice
                ).toFixed(this.MIN_FRACTION_DIGITS)
              }}&nbsp;{{ getFnBCurrency.curr_code }}
            </div>
          </div>
          <div
            class="row d-flex justify-content-center mt-1"
            v-if="USE_NEOLEAP_POS_PAYMENT == 'Y'"
          >
            <div class="machine-display">
              <div>
                <b-spinner
                  v-if="machineDisplay.processing"
                  label="Processing..."
                  class="translate-spinner"
                ></b-spinner>
              </div>
              <div v-if="machineDisplay.processing">Processing...</div>
               <div
                        v-if="
                          neoLeapTimeObjFnb.transactionTimeOut &&
                            machineDisplay.processing
                        "
                      >
                        Time Left:&nbsp;<span
                          class="font-weight-bold"
                          style="font-family: monospace;"
                          >{{ neoLeapTimeObjFnb.transactionTimeOut }}</span
                        >
                      </div>
            </div>
          </div>
          <div
            class="row d-flex justify-content-center mt-2"
            v-if="USE_NEOLEAP_POS_PAYMENT == 'Y'"
          >
            <div
              class="btn btn-primary"
              :class="machineDisplay.processing ? 'disCreditPayBtn' : ''"
              :disabled="machineDisplay.processing"
              @click="connectNeoLeap()"
            >
              Proceed
              {{
                parseFloat(
                  ticketValue +
                    FnBItemsTotalPrice +
                    selectedAddonsTotalPrice +
                    customizationTotalPrice
                ).toFixed(this.MIN_FRACTION_DIGITS)
              }}&nbsp;{{ getFnBCurrency.curr_code }}
            </div>
          </div>
          <div class="hidden-manual-btns text-center mt-3" v-if="USE_NEOLEAP_POS_PAYMENT == 'Y' && skipNeoleapResponse == 'Y'">
                      <div class="btn btn-primary mr-2 btn_min_width_190" @click="proceedNeoleapManually(1)">
                        <span>Payment Captured</span>
                      </div>
                      <div class="btn btn-outline-primary btn_min_width_190" @click="cancelNeoleapManually(1)">
                        <span>Cancel</span>
                      </div>
                    </div>
        </div>

        <div
          class="card-payment-contianer"
          v-if="selectedPaymentMode.pm_id == 10"
        >
          <h6 class="mb-3">
            {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
          </h6>
          <h6 class="mb-3">
            {{ $t("mobileno") }} : {{ customer_mobile_number }}
          </h6>
          <h6 class="mb-3">{{ $t("emailaddress") }} : {{ email_address }}</h6>
          <h6 class="mb-3">
            {{ $t("full") }} {{ $t("name") }} : {{ first_name }} {{ last_name }}
          </h6>

          <!-- <form> -->
          <label>Points Available</label>
          <input
            type="number"
            disabled
            :value="getAvailablePoints"
            placeholder="Points Available"
          />
          <label>Burn Points</label>
          <input
            type="number"
            disabled
            :value="getBurnPoints"
            placeholder="Burn Points"
          />
          <!-- </form> -->
          <button
            v-if="
              getBurnPoints > 0 &&
                !isLoyaltyApplied &&
                Object.keys(offerApplied).length == 0
            "
            class="fs-14 btn-blue-lg mb-2 ml-3 mt-3"
            @click="onApplyLoyalty()"
          >
            {{ $t("Apply") }}
          </button>
        </div>

        <div
          class="card-payment-contianer"
          v-if="selectedPaymentMode.pm_id == 25"
        >
          <div class="mb-3" :style="'font-size: 25px; font-weight: 600; color: var(--primary);'">
            {{ selectedPaymentMode.pm_payment_mode }}
          </div>

          <Ewallet
            :curr_code="currencyData.curr_code"
          />
        </div>
        <!-- <div
          class="card-payment-contianer dasdasdasdas"
          v-if="selectedPaymentMode.pm_id == 23"
        >
        <h6 class="mb-3">
            {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
          </h6>
          <MeritGiftCardSection
            :onClickAddMoney="onClickAddMoney"
          />
        </div> -->

        <div
                  class="card-payment-contianer"
                  v-if="giftCardPmIds.includes(String(selectedPaymentMode.pm_id))"
                >
                  <h6 class="mb-3">
                    {{ $t("payBy") }} {{ selectedPaymentMode.pm_payment_mode }}
                  </h6>
                  <section class="border-bottom giftcard_input">
                     <MeritGiftCardSection
                        v-if="selectedPaymentMode.pm_id == 23"
                        :onClickAddMoney="onClickAddMoney"
                        :onPayByGiftCard="onPayByGiftCard"
                      />
                  </section>

                  <section class="row voucher_btn_row mt-3">
                        <article
                          class="col-4"
                          v-for="(gc,
                          gcIndex) in giftCardsPaymentModes"
                          :key="gcIndex"
                        >
                          <div
                            class="voucher_btn"
                            @click="onSelectPaymentType(gc)"
                            :class="
                              selectedPaymentMode.pm_id == gc.pm_id
                                ? 'active'
                                : ''
                            "
                          >
                            <div class="voucher_btn__name">
                              <p>
                                {{ gc.pm_payment_mode }}
                              </p>
                            </div>
                          </div>
                        </article>
                      </section>
                </div>

        <div
          class="cashless-payments-container"
          v-if="
            selectedPaymentMode.pm_id == 4 ||
              selectedPaymentMode.pm_id == 5 ||
              selectedPaymentMode.pm_id == 6 ||
              selectedPaymentMode.pm_id == 7 ||
              selectedPaymentMode.pm_id == 8
          "
        >
          <h6 class="mb-3">Cashless Payment</h6>
          <div class="row">
            <div class="col-lg-6 col-xl-3">
              <button class="btn-cashlessPayment">
                <img
                  src="@/assets/img/pos/paymentTypes/applepay.png"
                  class="img-fluid"
                />
              </button>
            </div>

            <div class="col-lg-6 col-xl-3">
              <button class="btn-cashlessPayment">
                <img
                  src="@/assets/img/pos/paymentTypes/paypal.png"
                  height="auto"
                  width="80px"
                />
              </button>
            </div>

            <div class="col-lg-6 col-xl-3">
              <button class="btn-cashlessPayment">
                <img
                  src="@/assets/img/pos/paymentTypes/alipay.png"
                  height="auto"
                  width="100px"
                />
              </button>
            </div>

            <div class="col-lg-6 col-xl-3">
              <button class="btn-cashlessPayment">
                <img
                  src="@/assets/img/pos/paymentTypes/googlepay.png"
                  height="auto"
                  width="100px"
                />
              </button>
            </div>

            <div class="col-lg-6 col-xl-3">
              <button class="btn-cashlessPayment">
                <img
                  src="@/assets/img/pos/paymentTypes/samsungpay.png"
                  height="auto"
                  width="105px"
                />
              </button>
            </div>
          </div>
        </div>

        <div class="split-payment-container" v-if="paymentTypes.splitPayments">
          <h6 class="mb-3">Split Payment</h6>
        </div>

        <div class="coupon-container" v-if="paymentTypes.couponNPromotions">
          <h6 class="mb-3">Coupon Promotion</h6>
          <form>
            <div class="row">
              <div class="col-12 mb-4">
                <input type="text" placeholder="Coupons / Promotion Number" />
              </div>
            </div>
          </form>
        </div>

        <div class="voucher-container" v-if="paymentTypes.vouchers">
          <h6 class="mb-3">Vouchers</h6>
          <form>
            <div class="row">
              <div class="col-12 mb-4">
                <input type="text" placeholder="Card Numbers" />
              </div>
              <div class="col-12 mb-4">
                <input type="text" placeholder="Customer Name" />
              </div>
              <div class="col-12 mb-4">
                <input type="text" placeholder="Card / Coupon / Voucher No" />
              </div>
            </div>
          </form>
        </div>

        <div class="loyalty-container" v-if="paymentTypes.loyaltyCard">
          <h6 class="mb-3">Loyalty Card</h6>
          <form>
            <div class="row">
              <div class="col-12 mb-4">
                <input type="text" placeholder="Card Numbers" />
              </div>
              <div class="col-12 mb-4">
                <input type="text" placeholder="Customer Name" />
              </div>
              <div class="col-12 mb-4">
                <input type="text" placeholder="Mobile No" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <b-modal
      id="verifyVoucher"
      ref="verifyVoucher"
      title="Verify Voucher"
      hide-footer
      show
      @hide="clearVoucherCode"
      @shown="handleOpenVoucherCodeModal"
    >
      <div>
        <div class="row mb-3 mt-2">
          <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Voucher Code"
              type="text"
              autofocus
              v-model="voucherCodeValue"
              v-on:keyup.enter="
                applyFnbOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'fnbVouchers',
                  checkSpecificTitle: 'Y'
                })
              "
              @input="
                onEnterVoucherCode({
                  event: $event,
                  name: 'enterVoucherCode'
                })
              "
              name="voucherCode"
              id="voucherCode"
              class="form-control"
              ref="voucherCodemodal"
            />
            <label>{{ "Enter Voucher Code" }}</label>
            <VkeyboardFloat
              :ID="'voucherCode'"
              :onClickFun="
                () => {
                  Object.keys(keyboardsVisible).map(x => {
                    if (x == 'showVerifyVoucher') {
                      keyboardsVisible[x] = !keyboardsVisible[x];
                    } else {
                      keyboardsVisible[x] = false;
                    }
                  });
                }
              "
            />
            <Vkeyboard
              :inputName="'voucherCode'"
              :showOrHide="keyboardsVisible.showVerifyVoucher"
              :initialValue="voucherCodeValue"
              @onChangeEvent="() => {}"
              @onKeyEnter="
                applyOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'vouchers',
                  booking_source_id: 1,
                  checkSpecificTitle: 'Y'
                })
              "
              @changeKeyboardInput="
                event => {
                  voucherCodeValue = event;
                  onEnterVoucherCode({
                    event: {
                      target: {
                        value: event
                      }
                    },
                    name: 'enterVoucherCode'
                  });
                }
              "
              @onClickClose="
                () => {
                  keyboardsVisible.showVerifyVoucher = false;
                }
              "
            />
          </div>
          <div class="col-12 py-2 text-center">
            <button
              @click="
                applyFnbOffersHandler({
                  event: $event,
                  offer: selectedVoucherForVerifcation,
                  offerFor: 'fnbVouchers',
                  checkSpecificTitle: 'Y'
                })
              "
              class="btn-blue ml-5"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="total_discount_popup"
      ref="total_discount_popup"
      title="Total Discount"
      hide-footer
      show
      @hide="closeTotalDiscount"
      @shown="handleOpenModal"
    >
      <div>
        <div class="row mb-3 mt-2">
          <!-- <h6 class="px-3">Voucher Code</h6> -->
          <div class="col-10 mb-4 d-flex input-material mx-auto">
            <input
              placeholder="Enter Amount"
              type="number"
              autofocus
              v-on:keyup.enter="checkOpenVoucherAmount"
              v-model="totalofferDiscountov"
              name="totalofferDiscountov"
              id="totalofferDiscountov"
              ref="totalofferDiscountov"
              class="form-control"
            />
            <label>{{ "Enter Amount" }}</label>
          </div>

          <div class="pos-mobile-number">
            <div>
              <div class="row">
                <div class="col-12 mx-auto">
                  <div class="row">
                    <div
                      class="col-4 mb-2"
                      v-for="(value, index) in phone_value"
                      :key="index"
                    >
                      <button
                        v-if="index == phone_value.length - 1"
                        class="number"
                        v-on:click="sliceAmount()"
                      >
                        {{ value.name }}
                      </button>
                      <button
                        v-else-if="value.name != ''"
                        v-on:click="onClickamount(index)"
                        class="number"
                      >
                        {{ value.name }}
                      </button>
                      <button
                        v-else
                        @click.prevent.stop="clearInput"
                        class="number"
                      >
                        C
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 py-2 text-center">
            <button class="btn-blue" @click="checkOpenVoucherAmount">
              Apply
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="refund_cash_popup"
      ref="refund_cash_popup"
      title="Cash Refund"
      hide-footer
      show
      @hide="handleSubmit"
      @shown="handleRemainingPriceModal"
    >
      <div>
        <div class="row mb-3 mt-2">
          <h6 class="px-3">
            FNB Amount : {{ currFormat(Total_bill) }}
            {{ currencyData["curr_code"] }}
          </h6>
          <br />
          <h6 class="px-3">
            Voucher Amount :
            {{
              parseFloat(
                parseFloat(offerPrice) +
                  parseFloat(RemainingCashRefundOfferAmount)
              ).toFixed(this.MIN_FRACTION_DIGITS)
            }}
            {{ currencyData["curr_code"] }}
          </h6>
          <br />
          <h6 class="px-3">
            Refund Cash Amount: {{ RemainingCashRefundOfferAmount }}
            {{ currencyData["curr_code"] }}
          </h6>
          <div class="col-12 py-2 text-center">
            <input
              v-on:keyup.enter="handleSubmit()"
              type="text"
              autofocus
              style="width: 0; height: 0; border: #fff"
              v-model="remainingOfferPrice"
              ref="remainingOfferPrice"
            />
            <button class="btn-blue" type="submit" @click="handleSubmit">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </b-modal>
     <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Card Transaction Details"
      ref="manualCardDetailsNeoleap"
      id="manualCardDetailsNeoleap"
    >
      <div class="row settings-box mb-4">
        <div class="col-12 py-2">
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Terminal ID:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.CardAcceptorTerminalId"
                    type="text"
                    id="CardAcceptorTerminalId"
                    name="CardAcceptorTerminalId"
                    @click="onClickInputHandler('tidKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'CardAcceptorTerminalId'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'tidKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'CardAcceptorTerminalId'"
                  :showOrHide="keyboardsVisible.tidKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.CardAcceptorTerminalId
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.CardAcceptorTerminalId = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.tidKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Transaction RRN:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.RetrievalReferenceNumber"
                    type="text"
                    id="RetrievalReferenceNumber"
                    name="RetrievalReferenceNumber"
                    @click="onClickInputHandler('RRNKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'RetrievalReferenceNumber'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'RRNKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'RetrievalReferenceNumber'"
                  :showOrHide="keyboardsVisible.RRNKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.RetrievalReferenceNumber
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.RetrievalReferenceNumber = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.RRNKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2" v-if="false">
            <div class="col-4 d-flex align-items-center fs-11">Card No:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    @input="onInputCardNumber($event)"
                    placeholder="."
                    v-model="cardNumber_unMasked"
                    type="text"
                    id="PrimaryAccountNumber"
                    name="PrimaryAccountNumber"
                    @click="onClickInputHandler('cardNumberKeyboard')"
                  />
                  <span class="text-muted fs-10">{{
                    neoleapCardDetailsManual.PrimaryAccountNumber
                  }}</span>
                </div>
                <VkeyboardFloat
                  :ID="'PrimaryAccountNumber'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'cardNumberKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'PrimaryAccountNumber'"
                  :showOrHide="keyboardsVisible.cardNumberKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.PrimaryAccountNumber
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.PrimaryAccountNumber = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.cardNumberKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Approval Code:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.AID"
                    type="text"
                    id="AID"
                    name="AID"
                    @click="onClickInputHandler('AIDKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'AID'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'AIDKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'AID'"
                  :showOrHide="keyboardsVisible.AIDKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.AID
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.AID = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.AIDKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">
              Card Scheme:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.CardScheme"
                    type="text"
                    id="CardScheme"
                    name="CardScheme"
                    @click="onClickInputHandler('CardSchemeKeyboard')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'CardScheme'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'CardSchemeKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'AID'"
                  :showOrHide="keyboardsVisible.CardSchemeKeyboard"
                  :initialValue="
                    neoleapCardDetailsManual.CardScheme
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.CardScheme = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.CardSchemeKeyboard = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4 d-flex align-items-center fs-11">Card Name:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.CardNameEnglish"
                    type="text"
                    id="CardNameEnglish"
                    name="CardNameEnglish"
                    @click="onClickInputHandler('cardNameKeybaord')"
                  />
                </div>
                <VkeyboardFloat
                  :ID="'CardNameEnglish'"
                  :onClickFun="
                    () => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if (x == 'cardNameKeybaord') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      });
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'CardNameEnglish'"
                  :showOrHide="keyboardsVisible.cardNameKeybaord"
                  :initialValue="
                    neoleapCardDetailsManual.CardNameEnglish
                  "
                  @onChangeEvent="() => {}"
                  @onKeyEnter="()=> {}"
                  @changeKeyboardInput="
                    neoleapCardDetailsManual.CardNameEnglish = $event
                  "
                  @onClickClose="
                    () => {
                      keyboardsVisible.cardNameKeybaord = false;
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="row mb-2" v-if="false">
            <div class="col-4 d-flex align-items-center fs-11">
              ECR Reference:
            </div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="neoleapCardDetailsManual.ECRReferenceNumber"
                    type="text"
                    :disabled="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pt-3 text-center">
          <button
            v-on:click="neoleapManualCheckout()"
            class="btn-blue"
          >
            Checkout
          </button>
          <button
            @click.prevent.stop="$bvModal.hide('manualCardDetailsNeoleap')"
            class="btn-blue"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
    <promoOffersPopup
      :type="isBoxofficeflag && totalSeats.length > 0 ? 'BOXFNB' : 'FNB'"
    />
  </div>
</template>

<script>
import PosGlobalCalculator from "@/components/Partials/PosGlobalCalculator";
import MasterService from "@/services/MasterService.js";
import { mapState, mapGetters, mapActions } from "vuex";
import CashCardPos from "@/components/Partials/CashCardPos";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import promoOffersPopup from "@/components/Partials/PromoOffersPopup.vue";
import { EventBus, backendSocket } from "@/main";
import { generateRandomCode } from "@/helper/collection";
import MeritGiftCardSection from "@/components/Partials/MeritGiftCardSection";
import Ewallet from "@/components/Partials/EwalletPos";

export default {
  components: {
    PosGlobalCalculator,
    CashCardPos,
    Vkeyboard,
    VkeyboardFloat,
    promoOffersPopup,
    MeritGiftCardSection,
    Ewallet
  },
  data() {
    return {
      disableCheckoutBtn: false,
      transactionUniqId: generateRandomCode(8),
      giftCardPmIds: ['23'],
      skipNeoleapResponse: 'N',
      invoiceNumber: "",
      neo_orderRef: "",
      neo_ws: null,
      neo_retry_count: 0,
      neo_click_count: 0,
      machineDisplay: {
        displayText: "",
        status: true,
        processing: false
      },
      offerPopupType: "FNB",
      keyboardsVisible: {
        showVoucherCodeKeyboard: false,
        showCommentKeyboard: false,
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
        showInvoiceNumberKeyboard: false,
        showPaymentRemarkKeyboard: false,
        showVerifyVoucher: false,
        tidKeyboard: false,
        RRNKeyboard: false,
        cardNumberKeyboard: false,
        AIDKeyboard: false,
        CardSchemeKeyboard: false,
        cardNameKeybaord: false,
      },
      neoLeapTimeObjFnb: {
        timePassed: 0,
        timeLeft: 0,
        timerInterval: null,
        transactionTimeOut: `00:00`,
        timeInSec: 60
      },
      timTimeObj: {
        timePassed: 0,
        timeLeft: 0,
        timerIntervalFnb: null,
        transactionTimeOut: `00:00`,
        timeInSec: 120
      },
      totalofferDiscountov: "",
      remainingOfferPrice: "",
      selectedVoucherForVerifcation: null,
      voucherCodeValue: "",
      submitted: false,
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" }
      ],
      Countries: [],
      CodeListCopy: [],
      searchCode: "",
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      },
      VoucherCodeDeounce: "",
      neoleapSkipTimer: null,
      neoleapCardDetailsManual: {
        StatusCode: "00",
        MerchantNameEnglish: "",
        MerchantNameArabic: "",
        MerchantAddress1English: "",
        MerchantAddress2English: "",
        MerchantAddress1Arabic: "",
        MerchantAddress2Arabic: "",
        download_phone: "",
        TransactionDateTime: "",
        TransacitonRequestDateTime: "",
        TransactionResponseDateTime: "",
        BankId: "",
        CardAcceptorIdCode: "   ",
        CardAcceptorTerminalId: "",
        TerminalVersion: "",
        CardAcceptorBusinessCode: "",
        TransactionSTAN: "",
        RetrievalReferenceNumber: "",
        CardSchemeID: "",
        CardNameArabic: "",
        CardNameEnglish: "",
        CardScheme: "",
        PrimaryAccountNumber: "",
        CardExpiryDate: "",
        TransactionTypeArabic: "",
        TransactionTypeEnglish: "PURCHASE",
        TransactionAmount: "",
        TransactionResponseEnglish: "NO RESPONSE",
        TransactionResponseArabic: "",
        TransactionResultReasonEnglish: "NO RESPONSE",
        TransactionResultReasonArabic: "",
        ResponseCodeDescription: "",
        TransactionAuthCode: "",
        TerminalModel: "",
        POSEntryMode: "MANUAL",
        TransactionResponse: "000",
        AID: "",
        TVR: "",
        TSI: "",
        CVMResult: "",
        CryptResult: "",
        ApplicationCryptogram: "",
        KID: "",
        ECRReferenceNumber: "",
      },
    };
  },
  watch: {
    "this.$store.getters.getSelectedOffer": function(newVal) {
      console.log("newVal getSelectedOffer", newVal);
      if (!newVal || Object.keys(newVal).length == 0) {
        this.VoucherCodeDeounce = "";
      }
    }
  },
  computed: {
    routeName: function() {
      return this.$route.path;
    },
    giftCardsPaymentModes() {
      let payment_modes_array = [...this.$store.getters.paymentModes] || [];
      let giftCardPayementModes = payment_modes_array.filter((x) => this.giftCardPmIds.includes(String(x.pm_id))) || []
      return giftCardPayementModes
    },
    paymentModesFiltered() {
      let payment_modes_array = [...this.$store.getters.paymentModes] || [];
      let giftCardPayementModes = payment_modes_array.filter((x) => this.giftCardPmIds.includes(String(x.pm_id))) || []
      if(giftCardPayementModes && giftCardPayementModes.length > 0 && !payment_modes_array.some((p) => p.payment_mode_id == 'GiftCard')) {
        let pmObj = {
          pm_id: 'GiftCard',
          payment_mode_id: 'GiftCard',
          pm_payment_mode: 'Others'
        }
        payment_modes_array.push(pmObj);
      }
      let filterGiftCards = payment_modes_array.filter((y) => !this.giftCardPmIds.includes(String(y.pm_id)))
      return filterGiftCards
    },
    SELECTED_VOUCHER() {
      console.log(
        "this.$store.getters.tempOfferData",
        this.$store.getters.tempOfferData
      );
      return this.$store.getters.tempOfferData;
    },
     GET_MERIT_GIFT_CARD_DETAILS() {
      return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
    },
    MeritCardAmount() {
      let amount = 0;
      let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      if(gc_details) {
        amount = +parseFloat(gc_details['amount']).toFixed(this.MIN_FRACTION_DIGITS)
      }
      // return amount
      return 0;
    },
    eWalletAmount() {
      let amount = 0;
      let wallet_details = this.$store.getters.getWalletDetails;
      if(wallet_details) {
        amount = +parseFloat(wallet_details['redeem_amount']).toFixed(this.MIN_FRACTION_DIGITS)
      }
      return amount
    },
    POS_AMOUNT_CALCULATION_CHECK() {
      return this.$store.getters.POS_AMOUNT_CALCULATION_CHECK;
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice).toFixed(this.MIN_FRACTION_DIGITS) : 0;
    },
    RemainingCashRefundOfferAmount() {
      return this.$store.getters.RemainingCashRefundOffer;
    },
    openVoucherTotalGrossAmount() {
      return this.$store.getters.openVoucherTotalGrossAmount;
    },
    toPay() {
      let total =
        this.FnBItemsTotalPrice +
        this.ticketValue +
        this.selectedAddonsTotalPrice +
        this.customizationTotalPrice;
      return total;
    },
    Total_bill() {
      let total =
        this.FnBItemsTotalPrice +
        this.selectedAddonsTotalPrice +
        this.customizationTotalPrice;
      return total;
    },
    getCustMobCode() {
      return this.$store.getters.getCustMobCode;
    },
    offerApplied() {
      return this.$store.getters.getSelectedOffer;
    },
    ticketValue() {
      return (
        this.$store.getters.TOTAL_AMOUNT -
        this.$store.getters.getOfferPrice -
        this.$store.getters.paid_amount -
        this.$store.getters.getloyaltyAmount -
        parseFloat(this.MeritCardAmount || 0) -
        parseFloat(this.eWalletAmount || 0)
      );
    },
    totalSeats() {
      return this.$store.getters.SELECTED_SEATS;
    },
    input_number: {
      get() {
        return this.$store.getters.customer_mobile_number;
      },
      set(value) {
        this.$store.dispatch("updateCustomerMobileNumber", value);
      }
    },
    first_name: {
      get() {
        return this.$store.getters.first_name;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "fname",
          value: value
        });
      }
    },
    last_name: {
      get() {
        return this.$store.getters.last_name;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "lname",
          value: value
        });
      }
    },
    email_address: {
      get() {
        return this.$store.getters.email_address;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "email",
          value: value
        });
      }
    },
    is_loyality_subscribe: {
      get() {
        return this.$store.getters.is_loyality_subscribe;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "is_loyality_subscribe",
          value: value
        });
      }
    },
    isOldCustomer() {
      return this.$store.getters.getIsOldCustomer;
    },
    currencyData() {
      return this.$store.getters.getFnBCurrency;
    },
    cust_id() {
      return this.$store.getters.cust_id;
    },
    currencyCode() {
      return this.currencyData["curr_code"]
        ? this.currencyData["curr_code"]
        : "";
    },
    invoiceNumberComputed: {
      get() {
        return this.$store.getters.getInvoiceNumberForDeliveryCredit;
      },
      set(value) {
        this.$store.dispatch("updateInvoiceNumber", { value });
      }
    },
    // ...mapState(["fnbSearch"]),
    ...mapGetters([
      "Cashdata",
      "NEOLEAP_WEBSOCKET_URL",
      "USE_NEOLEAP_POS_PAYMENT",
      "ChangeAmount",
      "isBoxofficeflag",
      "paymentModes",
      "selectedPaymentMode",
      "getFnBCurrency",
      "TOTAL_AMOUNT",
      //
      "isEdit",
      "isSearch",
      "customer_mobile_number",
      "getOfferPrice",
      "getAvailablePoints",
      "getBurnPoints",
      "isLoyaltyApplied",
      "selectedAddonsTotalPrice",
      "cashCards",
      "selectedCashCard",
      "paidflag",
      "paid_amount",
      //
      "customizationTotalPrice",
      "customizationTaxesPrice",
      "disablePayNow",
      "getOffersVoucherCollection",
      "getTransactionComment",
      "getPaymentRemark",
      "getInvoiceNumberForDeliveryCredit",
      "OPEN_OFFER_POPUP_AUTOMATICALLY",
      "getOffersCollection",
      "USE_TIM_INTEGRATION",
      "USE_NEOLEAP_POS_PAYMENT"
    ]),
    ...mapState({
      FnBItemsTotalPrice: state =>
        state.FnBStore.selectedFnBItemsTotalPrice +
        state.FnBStore.totalAdditionalTaxes,
      totalFnBPlusAdditionalTaxes: state => state.FnBStore.totalAdditionalTaxes,
      cashInputValue: state =>
        parseFloat(state.FnBStore.cashInputValue).toFixed(this.MIN_FRACTION_DIGITS),
      paymentTypes: state => state.FnBStore.paymentTypes
    })
  },
  beforeDestroy() {
    if (this.neo_ws) {
      this.disConnectNeoLeap();
    }
    if (this.neoLeapTimeObjFnb.timerInterval) {
      this.onNeoLeapTimeOut();
    }
  },
  beforeMount() {
    this.ResetPaymentRemark();
    this.resetFnbReservation();
    this.machineDisplay.processing = false
    this.skipNeoleapResponse = 'N'
    this.resetNeoleapManualData();
    clearTimeout(this.neoleapSkipTimer);
    clearInterval(this.neoLeapTimeObjFnb.timerInterval);
    this.resetNeoLeapTimer();
    this.ResetInvoiceNumberForDeliveryCredit();
    EventBus.$emit("enableCheckOutBtn");
    EventBus.$on("enableCheckOutBtn", data => {
      this.disableCheckoutBtn = false;
    });
    this.setOnFnBPayloads({ event: null, name: "clearsearch" });
    if (this.timTimeObj.timerIntervalFnb) {
      this.onTransactionTimeOut();
    }
    if (this.neoLeapTimeObjFnb.timerInterval) {
      this.onNeoLeapTimeOut();
    }
  },
  destroyed() {
    if (this.timTimeObj.timerIntervalFnb) {
      this.onTransactionTimeOut();
    }
  },
  mounted() {
    let checkFlag = this.secureStore.get("BGOPCP") || "N";
    if (checkFlag && checkFlag == "Y") {
      this.$refs["fnb-customer-details"].show();
    }
    this.getCountriesList();
    setTimeout(() => {
      this.showNewOffersPopup(true);
    }, 500);

    EventBus.$on("TERMINAL_STATUS", data => {
      console.log("Terminal Status");
    });

    EventBus.$on("TRANSACTION_COMPLETED", data => {
      if (this.routeName == "/pos-fnb" || this.routeName == "/box-office-fnb") {
        this.creditPay(data);
      } else {
        console.log("TICKET_TRANSACTION");
      }
    });

    EventBus.$on("DISPLAY_CONTENT", data => {
      console.log("DISPLAY_CONTENT", data);
      this.machineDisplay.displayText = data ? data : "";
    });

    this.checkHardwareId();
    // this.fetchCurrencyCode({ curr_id: this.secureStore.get("BRGLOPCUR") });
  },
  methods: {
     insertNeoleapLog(logFile) {
      let logObj = {
        user_id: this.secureStore.get("USINFO").user_id,
        user_name: this.secureStore.get("USINFO").username,
        cine_name: this.secureStore.get("USINFO").cine_name,
        reservation_id: this.transactionUniqId,
        isTicket: 'N',
        isFnb: 'Y',
        data: logFile
      }
       if (this.isBoxofficeflag && this.totalSeats.length > 0) {
        logObj['isTicket'] = 'Y';
        logObj['isFnb'] = 'Y';
      } else {
        logObj['isTicket'] = 'N';
        logObj['isFnb'] = 'Y';
      }

      if(backendSocket && backendSocket.connected) {
        console.log('NeoLeap Log Inserted');
        backendSocket.emit("generate-neoleap-log", logObj);
      } 
    },
    checkCredit() {
      console.log(
        Object.keys(this.$store.getters.GET_SELECTED_STATION),
        "Object.keys(this.$store.getters.GET_SELECTED_STATION)"
      );
      if (Object.keys(this.$store.getters.GET_SELECTED_STATION).length) {
        if (this.$store.getters.GET_SELECTED_STATION.station_id) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    ...mapActions([
      "fetchFnBItems",
      "resetFnbReservation",
      "setOnFnBPayloads",
      "onSelectVoucher",
      "onResetOffersAndPrice",
      "onResetFnBCashAmout",
      "addCashHandler",
      "cashInputChange",
      "onOrderSubmit",
      "setPaymentMode",
      "fetchCurrencyCode",
      "onSelectPaymentType",
      //
      "onApplyLoyalty",
      "selectCashCard",
      "payCashCardFnbBox",
      "onBoxOfficeAndFnBOrderSubmit",
      "onClickVoucherBox",
      "onInputComment",
      "onInputRemark",
      "onInputInvoiceNumber",
      "ResetInvoiceNumberForDeliveryCredit",
      "ResetPaymentRemark",
      "onEnterVoucherCode",
      "applyFnbOffersHandler",
      "applyOpenVoucher",
      "applyBoxOfficeFnbOffersHandler"
    ]),
    resetNeoleapManualData() {
      let tempObj = {
        StatusCode: "00",
        MerchantNameEnglish: "",
        MerchantNameArabic: "",
        MerchantAddress1English: "",
        MerchantAddress2English: "",
        MerchantAddress1Arabic: "",
        MerchantAddress2Arabic: "",
        download_phone: "",
        TransactionDateTime: "",
        TransacitonRequestDateTime: "",
        TransactionResponseDateTime: "",
        BankId: "",
        CardAcceptorIdCode: "   ",
        CardAcceptorTerminalId: "",
        TerminalVersion: "",
        CardAcceptorBusinessCode: "",
        TransactionSTAN: "",
        RetrievalReferenceNumber: "",
        CardSchemeID: "",
        CardNameArabic: "",
        CardNameEnglish: "",
        CardScheme: "",
        PrimaryAccountNumber: "",
        CardExpiryDate: "",
        TransactionTypeArabic: "",
        TransactionTypeEnglish: "PURCHASE",
        TransactionAmount: "",
        TransactionResponseEnglish: "NO RESPONSE",
        TransactionResponseArabic: "",
        TransactionResultReasonEnglish: "NO RESPONSE",
        TransactionResultReasonArabic: "",
        ResponseCodeDescription: "",
        TransactionAuthCode: "",
        TerminalModel: "",
        POSEntryMode: "MANUAL",
        TransactionResponse: "000",
        AID: "",
        TVR: "",
        TSI: "",
        CVMResult: "",
        CryptResult: "",
        ApplicationCryptogram: "",
        KID: "",
        ECRReferenceNumber: "",
      };
      Object.keys(tempObj).map((key) => {
        this.neoleapCardDetailsManual[key] = tempObj[key];
      })
    },
     neoleapManualCheckout() {
      this.$bvModal.hide('manualCardDetailsNeoleap');
      let amount = parseFloat(
        this.ticketValue +
          this.FnBItemsTotalPrice +
          this.selectedAddonsTotalPrice +
          this.customizationTotalPrice
      ).toFixed(this.MIN_FRACTION_DIGITS);
      this.neoleapCardDetailsManual['TransactionAmount'] = amount
      this.neoleapCardDetailsManual['ECRReferenceNumber'] = this.neo_orderRef
      this.neoPaymentSuccessfull(this.neoleapCardDetailsManual);
    },
    onInputCardNumber(event) {
      let value = event.target.value;
      let maskNumber = this.maskCardNumber(value);
      this.neoleapCardDetailsManual.PrimaryAccountNumber = maskNumber;
    },
    maskCardNumber(cc, num = 4, mask = "*") {
      return (
        ("" + cc).slice(0, -num).replace(/./g, mask) + ("" + cc).slice(-num)
      );
    },
     resetNeoLeapTimer() {
      this.neoLeapTimeObjFnb.transactionTimeOut = `00:00`;
      this.neoLeapTimeObjFnb.timePassed = 0;
      this.neoLeapTimeObjFnb.timeLeft = 0;
      if (this.neoLeapTimeObjFnb.timeInSec) {
        const minutes = Math.floor(this.neoLeapTimeObjFnb.timeInSec / 60);
        let seconds = this.neoLeapTimeObjFnb.timeInSec % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.neoLeapTimeObjFnb.transactionTimeOut = `${minutes_n}:${seconds}`;
      } else {
        this.neoLeapTimeObjFnb.transactionTimeOut = `00:00`;
      }
    },
    onNeoLeapTimeOut() {
      this.neoLeapTimeObjFnb.transactionTimeOut = `00:00`;
      this.neoLeapTimeObjFnb.timePassed = 0;
      this.neoLeapTimeObjFnb.timeLeft = 0;
      this.neoLeapTimeObjFnb.timeInSec = 60;
      clearInterval(this.neoLeapTimeObjFnb.timerInterval);
      this.skipNeoleapResponse = 'Y';
      this.$forceUpdate();
    },
    startNeoLeapTimer() {
      clearInterval(this.neoLeapTimeObjFnb.timerInterval);
      this.resetNeoLeapTimer();
      this.neoLeapTimeObjFnb.timeLeft = this.neoLeapTimeObjFnb.timeInSec;
      this.neoLeapTimeObjFnb.timerInterval = setInterval(() => {
        this.neoLeapTimeObjFnb.timePassed = this.neoLeapTimeObjFnb.timePassed += 1;
        this.neoLeapTimeObjFnb.timeLeft =
          this.neoLeapTimeObjFnb.timeInSec - this.neoLeapTimeObjFnb.timePassed;
        if (this.neoLeapTimeObjFnb.timeLeft == 0) {
          this.onNeoLeapTimeOut();
        }
        const minutes = Math.floor(this.neoLeapTimeObjFnb.timeLeft / 60);
        let seconds = this.neoLeapTimeObjFnb.timeLeft % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.neoLeapTimeObjFnb.transactionTimeOut = `${minutes_n}:${seconds}`;
      }, 1000);
    },
    _startNeoleapTimer() {
      let self = this;
      this.neoleapSkipTimer = setTimeout(() => {
        self.skipNeoleapResponse = 'Y';
      }, 70 * 1000);
    },
    proceedNeoleapManually(type) {
      this.$bvModal.show('manualCardDetailsNeoleap')
    },
    cancelNeoleapManually(type, showToast = true, message = '') {
      let toastMsg = message ? message : 'Transaction Cancelled'
      if(showToast) {
        this.$toasted.show(toastMsg);
      }
      this.skipNeoleapResponse = 'N';
      this.machineDisplay.processing = false;
    },
    checkHardwareId() {
      let hardwareId = localStorage.getItem("deiviceUniqueCode");
      let hardwareMacAddress = localStorage.getItem("hardware_mac_address");
      if (!hardwareId || !hardwareMacAddress) {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          if (backendSocket && backendSocket.connected) {
            console.log("PINGING HARDWARE FROM HOME PAGE");
            backendSocket.emit("hardware-connected");
          }
        }
      }
    },
    neoPaymentSuccessfull(responseData) {
      //Make Booking
      console.log("Booking Processed!");
      let nl_cardName = responseData.hasOwnProperty("CardNameEnglish")
        ? responseData["CardNameEnglish"]
        : null;
      this.$store.commit(
        "SET_ALL_PAYMENT_CREDIT_CARD_TRANSATION_DATA",
        responseData
      );
      this.$store.commit("SET_CARD_GATEWAY_SERVICE", "NEOLEAP");
      this.$store.commit("SET_NL_CARD_NAME", nl_cardName);
      this.neo_orderRef = "";
      this.skipNeoleapResponse = 'N'
      this.machineDisplay.processing = false;
      clearTimeout(this.neoleapSkipTimer);
      clearInterval(this.neoLeapTimeObjFnb.timerInterval);
      this.neo_retry_count = 0;
      this.neo_click_count = 0;
      if (this.isBoxofficeflag && this.totalSeats.length > 0) {
        console.log("COMING HERE");
        this.onBoxOfficeAndFnBOrderSubmit({ isSplitPayment: false });
      } else {
        console.log("ONLY FNB ORDER creditPay");
        this.onOrderSubmit({ isSplitPayment: false });
      }
    },
    onPayByGiftCard() {
      if (this.isBoxofficeflag && this.totalSeats.length > 0) {
        console.log("COMING HERE");
        this.onBoxOfficeAndFnBOrderSubmit({ isSplitPayment: false });
      } else {
        console.log("ONLY FNB ORDER creditPay");
        this.onOrderSubmit({ isSplitPayment: false });
      }
    },
    neoPaymentFailed(responseData, message = "") {
      this.machineDisplay.processing = false;
      this.skipNeoleapResponse = 'Y'
      clearTimeout(this.neoleapSkipTimer);
      clearInterval(this.neoLeapTimeObjFnb.timerInterval);
      if (message) {
        this.$toasted.show(message);
      }
    },
    checkNeoLeapStatus(type) {
      this.startNeoLeapTimer();
      this.machineDisplay.processing = true;
      let checkObj = { Command: "CHECK_STATUS" };
      this.requestNeoLeap(JSON.stringify(checkObj));
    },
    connectNeoLeap(type) {
      this.createNeoleapWebSocket();
      this.neoPayType = type;
    },
    retryNeoTransaction() {
      this.neo_retry_count++;
      this.machineDisplay.processing = true;
      let lastTrxObj = { Command: "GET_LAST_TRX" };
      this.requestNeoLeap(JSON.stringify(lastTrxObj));
    },
    proceedNeoleap(type = 1) {
      // this.startNeoLeapTimer();
      this.neo_orderRef = generateRandomCode(8);
      this.machineDisplay.processing = true;
      let amount = parseFloat(
        this.ticketValue +
          this.FnBItemsTotalPrice +
          this.selectedAddonsTotalPrice +
          this.customizationTotalPrice
      ).toFixed(this.MIN_FRACTION_DIGITS);

      let paymentObj = {
        Command: "SALE",
        Amount: String(amount),
        Original_RRN: "",
        MaskedPAN: "",
        PrintFlag: "1",
        AdditionalData: String(this.neo_orderRef)
      };
      this.requestNeoLeap(JSON.stringify(paymentObj));
    },
    //Neoleap inTegration
    createNeoleapWebSocket() {
      let self = this;
      let WS_URL =
        this.NEOLEAP_WEBSOCKET_URL ||
        "wss://localhost:7000/neoleap_integration";
      this.neo_ws = new WebSocket(WS_URL);

      this.neo_ws.onopen = function() {
        // connection opened – add action here
        console.log("Connected");
        self.$toasted.show("Connected");
        self.checkNeoLeapStatus();
      };

      this.neo_ws.onmessage = function(evt) {
        console.log("onmessage evt", evt);
        if (evt.data) {
          let responseData = evt.data ? JSON.parse(evt.data) : "";
          self.insertNeoleapLog(responseData);
          console.log("responseData onmessage", responseData);

          if (
            !responseData.hasOwnProperty("EventName") &&
            !responseData.EventName &&
            responseData.hasOwnProperty("API_Status")
          ) {
            let errorMsg = `FAILED`;
            self.machineDisplay.processing = false;
            if(self.neo_click_count < 1) {
              self.skipNeoleapResponse = 'N'
              clearTimeout(self.neoleapSkipTimer);
              clearInterval(self.neoLeapTimeObjFnb.timerInterval);
              self.neo_click_count++;
            } else {
              self.skipNeoleapResponse = 'Y'
              clearTimeout(self.neoleapSkipTimer);
              clearInterval(self.neoLeapTimeObjFnb.timerInterval);
            }
            if (["2", "6"].includes(String(responseData.API_Status))) {
              if (self.neo_retry_count < 2) {
                self.retryNeoTransaction();
              } else {
                switch (responseData.API_Status) {
                  case "2":
                    errorMsg = `NO RESPONSE`;
                    break;
                  case "6":
                    errorMsg = `API TIMEOUT`;
                    break;
                  default:
                    errorMsg = `FAILED`;
                    break;
                }
                self.$toasted.show(errorMsg);
              }
            } else {
              switch (responseData.API_Status) {
                case "3":
                  errorMsg = `PORT ASSIGNED IS NOT PRESENT OR USED BY ANOTHER PROCESS.`;
                  break;
                case "4":
                  errorMsg = `UNEXPECTED ERROR OCCURRED, REQUEST CANCELLED`;
                  break;
                default:
                  errorMsg = `FAILED`;
                  break;
              }
              self.$toasted.show(errorMsg);
            }
            self.skipNeoleapResponse = 'Y'
          } else if (responseData.EventName == "TERMINAL_STATUS") {
            if (responseData.TerminalStatus == "READY") {
              self.proceedNeoleap(responseData);
            } else if (responseData.TerminalStatus == "BUSY") {
              self.neoPaymentFailed(
                responseData,
                "Terminal is " + responseData.TerminalStatus
              );
            } else {
              self.neoPaymentFailed(responseData, "Something Went Wring");
            }
          } else if (responseData.EventName == "TERMINAL_RESPONSE") {
            if (responseData.API_Status == "0") {
              if (
                responseData.hasOwnProperty("JsonResult") &&
                responseData.JsonResult
              ) {
                if (
                  responseData.JsonResult.StatusCode == "00" &&
                  responseData.JsonResult.TransactionTypeEnglish ==
                    "PURCHASE" &&
                  responseData.JsonResult.TransactionResponseEnglish ==
                    "APPROVED"
                ) {
                  if (
                    responseData.JsonResult.ECRReferenceNumber ==
                    self.neo_orderRef
                  ) {
                    self.$toasted.show(
                      responseData.JsonResult.TransactionResponseEnglish
                    );
                    self.neoPaymentSuccessfull(responseData.JsonResult);
                  } else {
                    self.neoPaymentFailed(
                      responseData,
                      "FAILED, PLEASE TRY AGAIN!"
                    );
                  }
                } else {
                  self.machineDisplay.processing = false;
                  self.$toasted.show(
                    responseData.JsonResult.TransactionResponseEnglish
                  );
                  self.skipNeoleapResponse = 'Y'
                  clearTimeout(self.neoleapSkipTimer);
                  clearInterval(self.neoLeapTimeObjFnb.timerInterval);
                }
              } else {
                self.machineDisplay.processing = false;
                self.$toasted.show("No Response");
                // self.retryNeoTransaction()
              }
            } else {
              // self.retryNeoTransaction()
              self.neoPaymentFailed(responseData, "Failed");
            }
          } else if (responseData.EventName == "TERMINAL_ACTION") {
            console.log("SWIPE CARD");
          } else {
            self.machineDisplay.processing = false;
          }
        } else {
          self.insertNeoleapLog(evt);
          console.log("ELSE evt", evt);
        }
      };
      this.neo_ws.onerror = function(evt) {
        console.log("evt.message onerror", evt.message);
        self.skipNeoleapResponse = 'Y'
        clearTimeout(self.neoleapSkipTimer);
        clearInterval(self.neoLeapTimeObjFnb.timerInterval);
        // error can be determined on evt.message
      };
      this.neo_ws.onclose = function() {
        console.log("Neo Leap Closed");
        // connection closed
      };
    },
    requestNeoLeap(jsonRequest) {
      if (this.neo_ws && this.neo_ws.readyState == WebSocket.OPEN) {
        console.log("requestNeoLeap jsonRequest", jsonRequest);
        var res = this.neo_ws.send(jsonRequest);
      } else {
        let e_msg = "Connection is Closed"
        this.neoPaymentFailed(null, e_msg)
        // this.$toasted.show("Connection is Closed " + this.neo_ws.readyState);
      }
    },
    disConnectNeoLeap() {
      this.neo_ws.close();
    },
    checkOfferTypeCount(offer) {
      let status = true;
      if (
        this.totalSeats.length == 0 &&
        offer.offer_type_id == 3 &&
        offer.oc_is_combo_with_fnb == "N"
      ) {
        status = false;
      } else if (
        offer.offer_redeem_at_concession == "N" &&
        this.totalSeats.length == 0
      ) {
        status = false;
      } else if (offer.offer_type_id == 1 && this.totalSeats.length == 0) {
        status = false;
      } else if (
        this.isBoxofficeflag &&
        this.totalSeats.length > 0 &&
        offer.offer_redeem_at_boxoffice == "N"
      ) {
        status = false;
      } else if (
        this.totalSeats.length == 0 &&
        offer.offer_redeem_at_concession == "N"
      ) {
        status = false;
      }
      console.log("offer, status", offer, status);
      return status;
    },
    checkOpenOfferModal() {
      let status = true;
      let checkOfferPaymentMode = this.paymentModes.filter(
        x => x.pm_id == 12 || x.pm_id == 13
      );
      let offerArray = this.getOffersCollection.filter(offer =>
        this.checkOfferTypeCount(offer)
      );

      if (offerArray.length > 0 && checkOfferPaymentMode.length > 0) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
    showNewOffersPopup(checkFlag = false) {
      if (checkFlag) {
        if (
          this.OPEN_OFFER_POPUP_AUTOMATICALLY == "Y" &&
          parseFloat(this.getOfferPrice).toFixed(this.MIN_FRACTION_DIGITS) == 0 &&
          this.checkOpenOfferModal()
        ) {
          this.$bvModal.show("promoOffersPopup");
        }
      } else {
        this.$bvModal.show("promoOffersPopup");
      }
    },
    startTimTimer() {
      clearInterval(this.timTimeObj.timerIntervalFnb);
      this.resetTimTimer();
      this.timTimeObj.timeLeft = this.timTimeObj.timeInSec;
      this.timTimeObj.timerIntervalFnb = setInterval(() => {
        this.timTimeObj.timePassed = this.timTimeObj.timePassed += 1;
        this.timTimeObj.timeLeft =
          this.timTimeObj.timeInSec - this.timTimeObj.timePassed;
        if (this.timTimeObj.timeLeft == 0) {
          this.onTransactionTimeOut();
        }
        const minutes = Math.floor(this.timTimeObj.timeLeft / 60);
        let seconds = this.timTimeObj.timeLeft % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.timTimeObj.transactionTimeOut = `${minutes_n}:${seconds}`;
      }, 1000);
    },
    resetTimTimer() {
      this.timTimeObj.transactionTimeOut = `00:00`;
      this.timTimeObj.timePassed = 0;
      this.timTimeObj.timeLeft = 0;
      if (this.timTimeObj.timeInSec) {
        const minutes = Math.floor(this.timTimeObj.timeInSec / 60);
        let seconds = this.timTimeObj.timeInSec % 60;
        let minutes_n = minutes;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        if (minutes < 10) {
          minutes_n = `0${minutes}`;
        }
        this.timTimeObj.transactionTimeOut = `${minutes_n}:${seconds}`;
      } else {
        this.timTimeObj.transactionTimeOut = `00:00`;
      }
    },
    onTransactionTimeOut() {
      this.timTimeObj.transactionTimeOut = `00:00`;
      this.timTimeObj.timePassed = 0;
      this.timTimeObj.timeLeft = 0;
      this.timTimeObj.timeInSec = 120;
      clearInterval(this.timTimeObj.timerIntervalFnb);
      if (typeof cancel == "function") {
        // this.$toasted.show('TimeOut!')
        cancel();
      }
      this.$forceUpdate();
    },
    onClickAddMoney() {},
    creditPay(data) {
      if (data.status) {
        if (data.data) {
          console.log("DATA.data creditPay", data.data);
          console.log("DATA.data creditPay", data.data);
          let trxobj = {
            trmTransRef: "",
            acqTransRef: "",
            sixTrxRefNum: "",
            cardholderName: "",
            cardNumber: "",
            cardNumberPrintable: "",
            cardRef: "",
            brandName: "",
            cardCountryCode: "",
            uid: "",
            aid: "",
            acc: ""
          };
          Object.keys(trxobj).map(key => {
            trxobj[key] = data.data[key];
          });
          this.$store.commit("SET_CREDIT_CARD_TRANSATION_DATA", trxobj);
          this.$store.commit("SET_CARD_GATEWAY_SERVICE", "TIM");
        }
        console.log("this.isBoxofficeflag creditPay", this.isBoxofficeflag);
        if (this.isBoxofficeflag && this.totalSeats.length > 0) {
          console.log("COMING HERE");
          this.onBoxOfficeAndFnBOrderSubmit({ isSplitPayment: false });
        } else {
          console.log("ONLY FNB ORDER creditPay");
          this.onOrderSubmit({ isSplitPayment: false });
        }
      }
      this.$toasted.show(data.message);
      this.machineDisplay.processing = false;
    },
    proceedCreditCard() {
      if (
        typeof purchase == "function" &&
        localStorage.getItem("ECR_INIT_STATUS")
      ) {
        this.startTimTimer();
        this.machineDisplay.processing = true;
        let amount = parseFloat(
          this.ticketValue +
            this.FnBItemsTotalPrice +
            this.selectedAddonsTotalPrice +
            this.customizationTotalPrice
        ).toFixed(this.MIN_FRACTION_DIGITS);
        purchase(amount, this.getFnBCurrency.curr_code);
      } else {
        this.machineDisplay.processing = false;
        this.$toasted.show("ECR Machine Not Active!");
      }
    },
    onClickFnbPay() {
      if (this.POS_AMOUNT_CALCULATION_CHECK == "N") {
        this.$store.commit(
          "SET_INPUT_AMOUNT",
          +parseFloat(this.toPay).toFixed(this.MIN_FRACTION_DIGITS)
        );
        this.disableCheckoutBtn = true
        this.onOrderSubmit({ isSplitPayment: false });
      } else if (this.cashInputValue >= this.toPay) {
        this.disableCheckoutBtn = true
        this.onOrderSubmit({ isSplitPayment: false });
      } else {
        this.$toasted.show("Please Add More Cash");
      }
    },
    onClickInputHandler(event) {
      if (
        Object.keys(this.keyboardsVisible).some(
          x => this.keyboardsVisible[x] == true
        )
      ) {
        Object.keys(this.keyboardsVisible).map(x => {
          if (x == event) {
            this.keyboardsVisible[x] = !this.keyboardsVisible[x];
          } else {
            this.keyboardsVisible[x] = false;
          }
        });
      }
    },
    sliceAmount() {
      this.open_ticket_discount_price = this.open_ticket_discount_price.slice(
        0,
        -1
      );
      this.totalofferDiscountov = parseInt(this.open_ticket_discount_price);
    },
    onClickamount: function(index) {
      if (this.open_ticket_discount_price) {
        this.open_ticket_discount_price = String(this.totalofferDiscountov);
      } else {
        this.open_ticket_discount_price = "";
      }
      this.open_ticket_discount_price += this.phone_value[index].name;
      this.totalofferDiscountov = parseInt(this.open_ticket_discount_price);
    },
    onRemoveOffer() {
      this.onResetOffersAndPrice();
      this.VoucherCodeDeounce = "";
    },
    checkOpenVoucherAmount() {
      if (this.totalofferDiscountov >= 0) {
        if (
          (this.openVoucherTotalGrossAmount >= this.totalofferDiscountov &&
            this.SELECTED_VOUCHER.is_allow_cash_refund == "N") ||
          this.SELECTED_VOUCHER.is_allow_cash_refund == "Y"
        ) {
          console.log(this.totalSeats.length, "this.totalSeats.length");
          this.applyOpenVoucher({
            amount: this.totalofferDiscountov,
            voucher: {
              offer: this.SELECTED_VOUCHER,
              offerFor:
                this.totalSeats.length > 0
                  ? "BoxOfficeFnbVouchers"
                  : "fnbVouchers"
            }
          });
        } else {
          this.$toasted.show(
            "Voucher Discount cannot be more than total gross price"
          );
        }
      } else {
        this.$toasted.show("Please Enter a Valid Amount");
      }
    },
    handleSubmit(e) {
      console.log(e);

      this.$refs.refund_cash_popup.hide();
    },
    handleRemainingPriceModal() {
      this.$refs.remainingOfferPrice.focus();
    },
    handleOpenModal() {
      this.$refs.totalofferDiscountov.focus();
    },
    closeTotalDiscount() {
      this.totalofferDiscountov = "";
    },
    clearVoucherCode() {
      this.voucherCodeValue = "";
    },
    handleOpenVoucherCodeModal() {
      this.$refs.voucherCodemodal.focus();
    },
    onInputVoucherCode: _.debounce(function(event) {
      console.log("event", event);
      if (this.VoucherCodeDeounce) {
        this.onEnterVoucherCode({
          event: {
            target: {
              value: this.VoucherCodeDeounce
            }
          },
          name: "enterVoucherCode"
        });
        this.applyFnbOffersHandler({
          event: null,
          offer: "",
          offerFor: "fnbVouchers",
          is_voucher_with_offers: true
        });
        // this.applyOffersHandler({
        //   event: null,
        //   offer: "",
        //   is_voucher_with_offers: true,
        //   offerFor: "vouchers",
        //   booking_source_id: 1
        // });
      } else {
        this.onResetOffersAndPrice();
      }
    }, 1 * 1000),
    onApplyVoucherBox(voucher) {
      this.onClickVoucherBox({ ...voucher, isFnbVoucher: true });
      this.selectedVoucherForVerifcation = voucher;
      this.onSelectVoucher(voucher);
    },
    getTicketTypePrice(voucher) {
      let text = ``;
      // if (voucher.hasOwnProperty("tt_id") && voucher.tt_id) {
      //   let checkValidation = true;
      //   if (voucher.hasOwnProperty("screen_id") && voucher.screen_id) {
      //     let Screen = this.TicketTypePricingArray.filter(
      //       (x) => x.screen_id == voucher.screen_id
      //     );
      //     if (Screen.length == 0) {
      //       checkValidation = false;
      //     }
      //   }
      //   let TicketType = this.TicketTypePricingArray.filter(
      //     (x) => x.tt_id == voucher.tt_id
      //   );

      //   if (TicketType && TicketType.length > 0 && checkValidation) {
      //     TicketType = _.orderBy(TicketType, ["total_amount"], ["asc"]);
      //     text = parseFloat(TicketType[0].total_amount).toFixed(this.MIN_FRACTION_DIGITS);
      //     return text;
      //   } else {
      //     return text;
      //   }
      // } else {
      //   return text;
      // }
      return text;
    },
    onClickPayBox() {
      if (this.POS_AMOUNT_CALCULATION_CHECK == "N") {
        this.$store.commit(
          "SET_INPUT_AMOUNT",
          +parseFloat(this.toPay).toFixed(this.MIN_FRACTION_DIGITS)
        );
        this.onBoxOfficeAndFnBOrderSubmit({ isSplitPayment: false });
      } else if (this.cashInputValue >= this.toPay) {
        this.onBoxOfficeAndFnBOrderSubmit({ isSplitPayment: false });
      } else {
        this.$toasted.show("Please Add More Cash");
      }
    },
    makePayment() {
      if (this.isBoxofficeflag && this.totalSeats.length > 0) {
        this.onBoxOfficeAndFnBOrderSubmit({ isSplitPayment: false });
      } else {
        this.onOrderSubmit({ isSplitPayment: false });
      }
    },
    onSearch: function() {
      if (!this.getCustMobCode) {
        this.$toasted.show("Please Select Country Code.");
      } else if (this.input_number.length == 0) {
        this.$toasted.show("Please enter Mobile Number.");
      } else if (this.getCustMobCode && this.input_number.length > 0) {
        this.$store.dispatch("setUserDeatils", {
          sb_mobile_number: this.input_number,
          onlySetUser: false,
          check_mob_code: true,
          country_mob_code: this.getCustMobCode
        });
      }
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.Countries = this.CodeListCopy.filter(x => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CodeListCopy;
      }
    },
    onSelectHandler: function(value) {
      this.SelectedCountryCode = value.country_mob_code;
      this.$store.dispatch("updateCountryMobCode", value.country_mob_code);
    },
    getCountriesList: function() {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CodeListCopy = data.Records;

            let defaultCon = data.Records.filter(c => {
              return c.country_mob_code == "966";
            });

            if (defaultCon.length > 0) {
              this.onSelectHandler(defaultCon[0]);
            }
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          console.log("show error :", error);
        });
    },
    onUpdateCustomerDetails() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (!this.getCustMobCode) {
            this.$toasted.show("Please Select Country Code.");
          } else if (this.input_number.length == 0) {
            this.$toasted.show("Please enter Mobile Number.");
          } else if (this.getCustMobCode && this.input_number.length > 0) {
            this.$store.dispatch("updateCustomerData", {
              first_name: this.first_name,
              last_name: this.last_name,
              mobile_number: this.input_number,
              cust_email: this.email_address,
              cust_id: this.cust_id,
              country_mob_code: this.getCustMobCode,
              is_loyality_subscribe: this.is_loyality_subscribe
            });
          }
        }
      });
    },
    onSaveDetails() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          if (!this.getCustMobCode) {
            this.$toasted.show("Please Select Country Code.");
          } else if (this.input_number.length == 0) {
            this.$toasted.show("Please enter Mobile Number.");
          } else if (this.getCustMobCode && this.input_number.length > 0) {
            this.$store.dispatch("updateOnlyCustomerDetails", {
              first_name: this.first_name,
              last_name: this.last_name,
              mobile_number: this.input_number,
              cust_email: this.email_address,
              cust_id: this.cust_id,
              // setOnlyUser: false,
              is_loyality_subscribe: this.is_loyality_subscribe,
              country_mob_code: this.getCustMobCode
            });
          }
        }
      });
    },
    clearInput: function() {
      this.input_number = "";
    },
    onClicknumber: function(index) {
      this.input_number += this.phone_value[index].name;
    },
    onEditPhoneNumber: function() {
      this.$store.dispatch("onEditPhoneNumber");
    },
    onSliceNUmber: function() {
      if (!this.isEdit) {
        this.$store.dispatch("sliceNumber");
      }
    },
    onClickDelete: function() {
      this.$store.dispatch("clearAllInput");
    },
    onSelectPaymentType: function(name) {
      console.log(name, "sdfdsfsdfsdf", this.isLoyaltyApplied);

      if (name.payment_mode_id == 13 && this.isLoyaltyApplied) {
        this.$toasted.show("Loyality Applied. You will not get offers");
        return false;
      }

      if ([2, 3].includes(name.payment_mode_id)) {
        if (this.USE_NEOLEAP_POS_PAYMENT == "Y") {
          console.log("calling neoleap");
          // this.createNeoleapWebSocket();
          this.machineDisplay.processing = false
          this.skipNeoleapResponse = 'N'
          this.resetNeoleapManualData();
          clearTimeout(this.neoleapSkipTimer);
          clearInterval(this.neoLeapTimeObjFnb.timerInterval);
          this.neo_retry_count = 0;
          this.neo_click_count = 0;
          this.resetNeoLeapTimer();
        }
      }

      if (
        ![2, 3].includes(name.payment_mode_id) &&
        this.machineDisplay.processing &&
        this.USE_TIM_INTEGRATION == "Y"
      ) {
        if (typeof cancel == "function") {
          cancel();
        }
        this.onTransactionTimeOut();
      }

      if (['GiftCard'].includes(String(name.payment_mode_id))) {
        console.log('COMING HERE LINE 6117', name.payment_mode_id);
        if (this.giftCardsPaymentModes && this.giftCardsPaymentModes.length > 0) {
          this.setPaymentMode(this.giftCardsPaymentModes[0]);
        }
      } else {
        this.setPaymentMode(name);
      }
    },
  },
};
</script>

<style>
.fnb-checkout-wrapper {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 225px);
}

.pm_disbaled {
  opacity: 0.5;
  pointer-events: none;
}

.voucher-box {
  height: 114px;
  margin: 22px;
  width: 40px;
  background: lightgray;
  border-radius: 10px;
}
.voucher_btn {
  background-color: var(--blue);
  color: white;
  border: 1px solid transparent;
  border-radius: 12px;
  /* padding: 16px; */
  padding: 8px;
  text-align: center;
  /* margin-bottom: 24px; */
  margin-bottom: 16px;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.5s, transform 0.5s, background-color 0.5s,
    color 0.5s;
  display: flex;
  flex-flow: column nowrap;
  /* height: 125px; */
  height: 80px;
  justify-content: center;
  align-items: center;
}

.voucher_btn:active {
  transform: scale(0.9);
}

.voucher_btn:active,
.voucher_btn.active,
.voucher_btn:hover {
  background-color: white;
  box-shadow: 0px 2px 6px -1px;
  color: var(--blue);
  border-color: var(--blue);
}

.giftcard_input {
  min-height: 175px;
}

.voucher_btn.inactive {
  /* background-color: grey;
  cursor: default;
  pointer-events: none;
  opacity: 0.2; */
  background-color: lightgray;
  cursor: default;
  pointer-events: none;
  opacity: 0.3;
  color: black;
}

.voucher_btn .voucher_btn__name > p {
  font-size: 18px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* -webkit-line-clamp: 2; */
  -webkit-line-clamp: 1;
  margin-bottom: 0;
}

.voucher_btn .voucher_btn__screen > p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__time > p {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__details {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.voucher_btn .voucher_btn__name + .voucher_btn__details {
  margin-top: 4px;
}

.voucher_btn .voucher_btn__details > div:nth-last-child(2) {
  max-width: 65%;
}

.voucher_btn .voucher_btn__details > div:nth-child(2) {
  margin-left: 12px;
}

.voucher_btn_row > article.col-6:nth-child(odd) {
  padding-right: 8px;
}

.voucher_btn_row > article.col-6:nth-child(even) {
  padding-right: 8px;
}

.pos_booking_input_material .input-material input:focus + label,
.pos_booking_input_material
  .input-material
  input:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material-textarea
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material .input-material input.is_active + label {
  left: 36px;
  top: -5px;
  background-color: #fff;
  color: var(--blue);
  font-size: 12px;
}

.pos_booking_input_material .input-material input.is_active {
  color: #495057;
  background-color: #fff;
  /* border-color: #80bdff; */
  outline: 0;
  /* -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
  /* box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
}

.pos_booking_input_material .input-material input + label,
.input-material textarea + label,
.input-material-textarea textarea + label {
  top: 18px;
  left: 36px;
}

@media (max-width: 1200px) {
  .pos-movie-listing-wrapper .btn-blue-lg {
    height: 40px !important;
    font-size: 12px;
  }

  .search-input .form-control {
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/posFnbCheckout.vue